import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { APIError, getExceptionPayload } from '../axiosConfiguration'
import { LoginResponse } from '../type/authentication'
import * as layoutActions from './layout'

export const doLogin = createAsyncThunk<Required<LoginResponse>, string, { rejectValue: APIError }>(
  'authentication/doLogin',
  async (code, { dispatch, rejectWithValue }) => {
    dispatch(layoutActions.startLoading())

    try {
      const requestParams = new URLSearchParams()
      requestParams.append('grant_type', 'authorization_code')
      requestParams.append('client_id', `${process.env.REACT_APP_CLIENT_ID}`)
      requestParams.append('client_secret', `${process.env.REACT_APP_CLIENT_SECRET}`)
      requestParams.append('redirect_uri', `${process.env.REACT_APP_BASE_URL}`)
      requestParams.append('code', code)

      const res = await axios.post<Required<LoginResponse>>(
        `${process.env.REACT_APP_COGNITO_URL}/oauth2/token`,
        requestParams,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        },
      )

      dispatch(layoutActions.endLoading())

      return res.data
    } catch (error) {
      dispatch(layoutActions.endLoading())
      return rejectWithValue(getExceptionPayload(error))
    }
  },
)
